import React from 'react';
import { EnvironmentProvider } from '../../contexts/EnvironmentContext';
import Hero from './components/Hero';
import { TEnvConfig } from 'types/TServerContext';

type TParams = {
  environment: TEnvConfig;
  pageKey: string;
};

const HeroApp = ({ environment, pageKey }: TParams) => (
  <EnvironmentProvider value={environment}>
    <Hero pageKey={pageKey} />
  </EnvironmentProvider>
);

export default HeroApp;
